export default "__VITE_ASSET__CLiKtN0u__"